export const NO_ROLES_MAPPED = 'No roles have been mapped to your account. Please contact the administrator for assistance.';
